import React, { useState } from "react";
import {
  locations,
  courses,
  specializations,
  institutes,
  startYears,
  endYears,
  skills,
} from "../data/dropdowndata";
import "../styles/candidateprofile.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Candidateprofile() {

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobile: "",
    otp: "",
    isVerified: false,
    location: "",
    Gender: "",
    yearsOfExp: "",
    qualification: "",
    course: "",
    courseType: "",
    specialization: "",
    institute: "",
    startYear: "",
    endYear: "",
    keySkills: [],
  });

  const [locationQuery, setLocationQuery] = useState("");
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [showLocationList, setShowLocationList] = useState(false);

  const [courseQuery, setCourseQuery] = useState("");
  const [filteredCourse, setFilteredCourse] = useState([]);
  const [showCourseList, setShowCourseList] = useState(false);

  const [specializationQuery, setSpecializationQuery] = useState("");
  const [filteredSpecializations, setFilteredSpecializations] = useState([]);
  const [showSpecializationList, setShowSpecializationList] = useState(false);

  const [instituteQuery, setInstituteQuery] = useState("");
  const [filteredInstitutes, setFilteredInstitutes] = useState([]);
  const [showInstituteList, setShowInstituteList] = useState(false);

  const [skillQuery, setSkillQuery] = useState("");
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [showSkillList, setShowSkillList] = useState(false);

  const [otpSent, setOtpSent] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState("");
  const navigate = useNavigate();

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // LOCATION autocomplete
  const handleLocationChange = (e) => {
    const value = e.target.value;
    setLocationQuery(value);
    setFormData({ ...formData, location: value });
    if (value.trim().length > 0) {
      const filtered = locations.filter((loc) =>
        loc.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredLocations(filtered);
      setShowLocationList(true);
    } else {
      setShowLocationList(false);
    }
  };

  const handleLocationSelect = (loc) => {
    setFormData({ ...formData, location: loc });
    setLocationQuery(loc);
    setShowLocationList(false);
  };

  const handleCourseChange = (e) => {
    const value = e.target.value;
    setCourseQuery(value);
    setFormData({ ...formData, course: value });
    if (value.trim().length > 0) {
      const filtered = courses.filter((cour) =>
        cour.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCourse(filtered);
      setShowCourseList(true);
    } else {
      setShowCourseList(false);
    }
  };

  const handleCourseSelect = (cour) => {
    setFormData({ ...formData, course: cour });
    setCourseQuery(cour);
    setShowCourseList(false);
  };


  const handleSpecializationChange = (e) => {
    const value = e.target.value;
    setSpecializationQuery(value);
    setFormData({ ...formData, specialization: value });
    if (value.trim().length > 0) {
      const filtered = specializations.filter((spec) =>
        spec.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSpecializations(filtered);
      setShowSpecializationList(true);
    } else {
      setShowSpecializationList(false);
    }
  };

  const handleSpecializationSelect = (spec) => {
    setFormData({ ...formData, specialization: spec });
    setSpecializationQuery(spec);
    setShowSpecializationList(false);
  };

  // ------------------ INSTITUTE AUTOCOMPLETE ------------------
  const handleInstituteChange = (e) => {
    const value = e.target.value;
    setInstituteQuery(value);
    setFormData({ ...formData, institute: value });
    if (value.trim().length > 0) {
      const filtered = institutes.filter((inst) =>
        inst.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredInstitutes(filtered);
      setShowInstituteList(true);
    } else {
      setShowInstituteList(false);
    }
  };

  const handleInstituteSelect = (inst) => {
    setFormData({ ...formData, institute: inst });
    setInstituteQuery(inst);
    setShowInstituteList(false);
  };





  // SKILLS autocomplete
  const handleSkillChange = (e) => {
    const value = e.target.value;
    setSkillQuery(value);
    if (value.trim().length > 0) {
      const filtered = skills.filter(
        (skill) =>
          skill.toLowerCase().includes(value.toLowerCase()) &&
          !formData.keySkills.includes(skill)
      );
      setFilteredSkills(filtered);
      setShowSkillList(true);
    } else {
      setShowSkillList(false);
    }
  };

  const handleSkillSelect = (skill) => {
    setFormData({ ...formData, keySkills: [...formData.keySkills, skill] });
    setSkillQuery("");
    setShowSkillList(false);
  };

  const removeSkill = (skill) => {
    setFormData({
      ...formData,
      keySkills: formData.keySkills.filter((s) => s !== skill),
    });
  };

  // OTP logic
  const handleSendOtp = () => {
    if (formData.mobile.trim().length === 10) {
      const otp = Math.floor(1000 + Math.random() * 9000).toString();
      setGeneratedOtp(otp);
      alert(`OTP sent to ${formData.mobile}: ${otp}`); // simulate OTP
      setOtpSent(true);
    } else {
      alert("Enter a valid 10-digit mobile number");
    }
  };

  const handleVerifyOtp = () => {
    if (formData.otp === generatedOtp) {
      setFormData({ ...formData, isVerified: true });
      alert("Mobile number verified!");
      setOtpSent(false);
    } else {
      alert("Invalid OTP, please try again");
    }
  };

  const qualifications = [
    "Below 10th",
    "10th",
    "12th",
    "Diploma",
    "Graduation",
    "Post Graduation",
    "Doctorate",
  ];

  const hideEducationFields = ["10th", "12th", "Below 10th"].includes(
    formData.qualification
  );

  const handleSkillKeyDown = (e) => {
    if (e.key === "Enter" && skillQuery.trim() !== "") {
      e.preventDefault();

      const newSkill = skillQuery.trim();

      if (!formData.keySkills.includes(newSkill)) {
        setFormData({
          ...formData,
          keySkills: [...formData.keySkills, newSkill],
        });
      }

      setSkillQuery("");
      setShowSkillList(false);
    }
  };

  {/*const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    alert("Form submitted successfully!");
  };*/}
  // After intergration with backend code 

  {/*const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      //user_id: 1, 
      full_name: formData.fullName,
      email: formData.email,
      mobile: formData.mobile,
      is_verified: formData.isVerified,
      location: formData.location,
      gender: formData.Gender,
      work_status: "Employed",
      years_of_exp: formData.yearsOfExp,
      qualification: formData.qualification,
      course: formData.course,
      course_type: formData.courseType,
      specialization: formData.specialization,
      institute: formData.institute,
      start_year: formData.startYear,
      end_year: formData.endYear,
      key_skills: formData.keySkills,
    };

    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.post(
        "http://localhost:8002/api/candidate/onboard",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        }
      );

      console.log("Backend response:", response.data);

      // SUCCESS CASE
      if (response.data.status === "success") {
        alert("Candidate profile saved successfully!");

        // Redirect with backend user_id
        //const redirectUserId = response.data.user_id || payload.user_id;

        // navigate("/candidate-profile");
        navigate("/candidate-dashboard")
        return;
      }

      // ALREADY EXISTS CASE
      if (response.data.status === "exists") {
        alert("Candidate already exists!");
        return;
      }

    } catch (error) {
      console.error("❌ Error saving candidate:", error);
      alert("Error saving candidate profile");
    }
  };*/}

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("auth_token");// OR whichever storage you're using

    //const decoded = JSON.parse(atob(token.split(".")[1])); // Decode JWT to get user_id added on 8-12-2025
    // added try catch for invalid token 0n 8-12-2025
    if (!token) {
      alert("You are not logged in!");
      return;
    }

    // STEP 2 — Decode token safely
    let decoded;
    try {
      decoded = JSON.parse(atob(token.split(".")[1]));
      console.log("DECODED TOKEN:", decoded);
    } catch (err) {
      console.error("❌ Invalid JWT:", err);
      alert("Invalid or corrupted token—please log in again.");
      return;
    }


    console.log("TOKEN SENT TO BACKEND:", token); // For debugging purpose 


    const payload = {
      //user_id: decoded.sub, // Decode JWT to get user_id added on 8-12-2025
      full_name: formData.fullName,
      email: formData.email,
      mobile: formData.mobile,
      is_verified: formData.isVerified,
      location: formData.location,
      gender: formData.Gender,
      work_status: "Employed",
      years_of_exp: formData.yearsOfExp,
      qualification: formData.qualification,
      course: formData.course,
      course_type: formData.courseType,
      specialization: formData.specialization,
      institute: formData.institute,
      start_year: formData.startYear,
      end_year: formData.endYear,
      key_skills: formData.keySkills,
    };

    try {


      const response = await axios.post(
        //"http://144.91.102.67:8001/api/candidate/onboard",
        //"http://144.91.102.67:8002/api/candidate/onboard",
        "https://stridenext.in/api/candidate/onboard",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,   // ✅ ADD THIS
          }
        }
      );

      console.log("Backend response:", response.data);

      // SUCCESS CASE
      if (response.data.status === "success") {
        alert("Candidate profile saved successfully!");

        // Redirect with backend user_id
        //const redirectUserId = response.data.user_id || payload.user_id;

        // navigate("/candidate-profile");
        navigate("/candidate-dashboard")
        return;
      }

      // ALREADY EXISTS CASE
      if (response.data.status === "exists") {
        alert("Candidate already exists!");
        return;
      }

    } catch (error) {
      console.error("❌ Error saving candidate:", error);
      alert("Error saving candidate profile");
    }
  };


  return (
    <div className="form-container">
      <h2>Profile Highlights</h2>
      <form onSubmit={handleSubmit}>
        {/* Personal Details */}
        <div className="form-section">
          <label>Full Name</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Enter your name"
            required
          />

          <label>Email</label>
          <input
            type="text"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            required
          />

          <label>Mobile Number</label>
          <div className="mobile-verify">
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              maxLength="10"
              placeholder="Enter your mobile number"
              required
            />
            {!formData.isVerified && !otpSent && (
              <button
                type="button"
                className="verify-btn"
                onClick={handleSendOtp}
              >
                Verify
              </button>
            )}
            {formData.isVerified && (
              <button type="button" className="verified-btn" disabled>
                Verified
              </button>
            )}
          </div>

          {otpSent && (
            <div className="otp-section">
              <input
                type="text"
                name="otp"
                value={formData.otp}
                onChange={handleChange}
                placeholder="Enter OTP"
                maxLength="4"
              />
              <button type="button" onClick={handleVerifyOtp}>
                Submit OTP
              </button>
            </div>
          )}

          <label>Current Location</label>
          <div className="autocomplete-wrapper">
            <input
              type="text"
              value={locationQuery}
              onChange={handleLocationChange}
              placeholder="Type to search location..."
              autoComplete="off"
              required
            />
            {showLocationList && filteredLocations.length > 0 && (
              <ul className="autocomplete-list">
                {filteredLocations.map((loc, i) => (
                  <li key={i} onClick={() => handleLocationSelect(loc)}>
                    {loc}
                  </li>
                ))}
              </ul>
            )}
          </div>

          <label>Gender</label>
          <div className="radio-group">
            <label>
              <input
                type="radio"
                name="Gender"
                value="Male"
                checked={formData.Gender === "Male"}
                onChange={handleChange}
              />
              Male
            </label>
            <label>
              <input
                type="radio"
                name="Gender"
                value="Female"
                checked={formData.Gender === "Female"}
                onChange={handleChange}
              />
              Female
            </label>
          </div>

          {formData && (
            <>
              <label>Years of Experience</label>
              <select
                name="yearsOfExp"
                value={formData.yearsOfExp}
                onChange={handleChange}
              >
                <option value="">Select years</option>
                {[...Array(31).keys()].map((y) => (
                  <option key={y} value={y}>
                    {y} year{y !== 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </>
          )}
        </div>

        {/* Education */}
        <div className="form-section">
          <label>Highest Qualification</label>
          <div className="qualification-buttons">
            {qualifications.map((q) => (
              <button
                type="button"
                key={q}
                className={`qual-btn ${formData.qualification === q ? "active" : ""
                  }`}
                onClick={() => setFormData({ ...formData, qualification: q })}
              >
                {q}
              </button>
            ))}
          </div>

          {!hideEducationFields && (
            <>
              <label>Course</label>
              <div className="autocomplete-wrapper">
                <input
                  type="text"
                  value={courseQuery}
                  onChange={handleCourseChange}
                  placeholder="Type to search course..."
                  autoComplete="off"
                />
                {showCourseList && filteredCourse.length > 0 && (
                  <ul className="autocomplete-list">
                    {filteredCourse.map((cour, i) => (
                      <li key={i} onClick={() => handleCourseSelect(cour)}>
                        {cour}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              {/* <select
                name="course"
                value={formData.course}
                onChange={handleChange}
              >
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course} value={course}>
                    {course}
                  </option>
                ))}
              </select> */}

              {/* SPECIALIZATION AUTOCOMPLETE */}
              <label>Specialization</label>
              <div className="autocomplete-wrapper">
                <input
                  type="text"
                  value={specializationQuery}
                  onChange={handleSpecializationChange}
                  placeholder="Type to search specialization..."
                  autoComplete="off"
                />
                {showSpecializationList && filteredSpecializations.length > 0 && (
                  <ul className="autocomplete-list">
                    {filteredSpecializations.map((spec, i) => (
                      <li key={i} onClick={() => handleSpecializationSelect(spec)}>
                        {spec}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </>
          )}

          <label>Institute</label>
          <div className="autocomplete-wrapper">
            <input
              type="text"
              value={instituteQuery}
              onChange={handleInstituteChange}
              placeholder="Type to search institute..."
              autoComplete="off"
            />
            {showInstituteList && filteredInstitutes.length > 0 && (
              <ul className="autocomplete-list">
                {filteredInstitutes.map((inst, i) => (
                  <li key={i} onClick={() => handleInstituteSelect(inst)}>
                    {inst}
                  </li>
                ))}
              </ul>
            )}
          </div>

          <label>Start Year</label>
          <select
            name="startYear"
            value={formData.startYear}
            onChange={handleChange}
          >
            <option value="">Select Year</option>
            {startYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>

          <label>End Year</label>
          <select
            name="endYear"
            value={formData.endYear}
            onChange={handleChange}
          >
            <option value="">Select Year</option>
            {endYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        {/* Key Skills */}
        <div className="form-section">
          <label>Key Skills</label>
          <div className="autocomplete-wrapper">
            <input
              type="text"
              value={skillQuery}
              onChange={handleSkillChange}
              placeholder="Type to search skills..."
              onKeyDown={handleSkillKeyDown}
              autoComplete="off"
            />
            {showSkillList && filteredSkills.length > 0 && (
              <ul className="autocomplete-list">
                {filteredSkills.map((skill, i) => (
                  <li key={i} onClick={() => handleSkillSelect(skill)}>
                    {skill}
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="skills-tags">
            {formData.keySkills.map((skill) => (
              <span key={skill} className="skill-tag">
                {skill}{" "}
                <button type="button" onClick={() => removeSkill(skill)}>
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>

        <button type="submit" className="save-btn">
          Save & Continue
        </button>
      </form>
    </div>
  );
}

export default Candidateprofile;
